<button type="{{ isSubmitType ? 'submit' : 'button' }}" class="santa-typo-regular-bold santa-block {{ type + '-' + mode }}" [class.full-width]="fullWidth" [disabled]="disabled" (click)="clicked()">
  <ng-content></ng-content>
</button>
